import { Button } from "@/components/ui/button";
import { GridFour as Grid3x3, List } from "@phosphor-icons/react";
import { useState, useEffect } from "react";

type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
      <Button
        variant={value === 'grid' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 px-3"
        onClick={() => onChange('grid')}
        title="Vizualizare Grilă"
      >
        <Grid3x3 className="h-4 w-4 mr-1" />
        <span className="hidden sm:inline">Grilă</span>
      </Button>
      <Button
        variant={value === 'list' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 px-3"
        onClick={() => onChange('list')}
        title="Vizualizare Listă"
      >
        <List className="h-4 w-4 mr-1" />
        <span className="hidden sm:inline">Listă</span>
      </Button>
    </div>
  );
};

export const useViewMode = () => {
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    try {
      const saved = localStorage.getItem('vehicleViewMode');
      return (saved as ViewMode) || 'grid';
    } catch {
      return 'grid';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('vehicleViewMode', viewMode);
    } catch (error) {
      console.error('Failed to save view mode:', error);
    }
  }, [viewMode]);

  return { viewMode, setViewMode };
};
